export default __webpack_public_path__ + "static/poster-9873bc27526ecb35b74b94cc569c47d1.png";